import React from 'react'
import {
  Navigate,
  createBrowserRouter,
  useParams,
  useSearchParams,
  type RouteObject,
} from 'react-router-dom'
import App from '../App'

import HomePageSync from './HomePage.jsx'
import CourseTabPageSync from './course/CourseTabPage.jsx'
import FolderIndexSync from './course/FolderIndex.jsx'
import FolderPageSync from './course/FolderPage.jsx'
import FreeContentPageSync from './course/FreeContentPage.jsx'
import PhysicalAddressPageSync from './course/PhysicalAddressPage.jsx'
import VideoPreviewPageSync from './course/VideoPreviewPage.jsx'
import TestStatsPageSync from './course/TestStatsPage.jsx'
import QrCheckoutPageSync from './checkout/QrCheckoutPage.jsx'
import NotFoundPageSync from './errors/NotFoundPage.jsx'
import TimeoutPageSync from './errors/TimeoutPage.jsx'
import ServerErrorPageSync from './errors/ServerErrorPage.jsx'
import NoInternetPageSync from './errors/NoInternetPage.jsx'

function CourseIdRedirect() {
  const { courseId } = useParams()
  const [sp] = useSearchParams()
  const qs = sp.toString()
  return <Navigate to={`/${courseId}/1${qs ? `?${qs}` : ''}`} replace />
}

function FolderZeroRedirect({ children }: { children: React.ReactNode }) {
  const { courseId, folderId } = useParams()
  const [sp] = useSearchParams()
  if (folderId === '0') {
    const token = sp.get('token') || ''
    return (
      <Navigate
        to={`/${courseId}/2${token ? `?token=${encodeURIComponent(token)}` : ''}`}
        replace
      />
    )
  }
  return <>{children}</>
}

function layoutHandle(Page: { getLayoutProps?: () => Record<string, unknown> }) {
  return { getLayoutProps: () => Page.getLayoutProps?.() || {} }
}

const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      { path: '/', element: <HomePageSync />, handle: layoutHandle(HomePageSync) },
      { path: '/404', element: <NotFoundPageSync />, handle: layoutHandle(NotFoundPageSync) },
      { path: '/408', element: <TimeoutPageSync />, handle: layoutHandle(TimeoutPageSync) },
      { path: '/500', element: <ServerErrorPageSync />, handle: layoutHandle(ServerErrorPageSync) },
      { path: '/504', element: <NoInternetPageSync />, handle: layoutHandle(NoInternetPageSync) },
      {
        path: '/checkout/qr',
        element: <QrCheckoutPageSync />,
        handle: layoutHandle(QrCheckoutPageSync),
      },
      { path: '/:courseId', element: <CourseIdRedirect /> },
      {
        path: '/:courseId/:tabId',
        element: <CourseTabPageSync />,
        handle: layoutHandle(CourseTabPageSync),
      },
      {
        path: '/:courseId/folder',
        element: <FolderIndexSync />,
        handle: layoutHandle(FolderIndexSync),
      },
      {
        path: '/:courseId/folder/:folderId',
        element: (
          <FolderZeroRedirect>
            <FolderPageSync />
          </FolderZeroRedirect>
        ),
        handle: layoutHandle(FolderPageSync),
      },
      {
        path: '/:courseId/freecontent',
        element: <FreeContentPageSync />,
        handle: layoutHandle(FreeContentPageSync),
      },
      {
        path: '/:courseId/physicaladdress',
        element: <PhysicalAddressPageSync />,
        handle: layoutHandle(PhysicalAddressPageSync),
      },
      {
        path: '/:courseId/videopreview',
        element: <VideoPreviewPageSync />,
        handle: layoutHandle(VideoPreviewPageSync),
      },
      {
        path: '/:courseId/teststats/:testId/:contentId',
        element: <TestStatsPageSync />,
        handle: layoutHandle(TestStatsPageSync),
      },
      { path: '*', element: <NotFoundPageSync />, handle: layoutHandle(NotFoundPageSync) },
    ],
  },
]

export const router = createBrowserRouter(routes)
